<template>
	<div class="wave">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
			<path
				d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
				class="shape-fill"
				:style="{ fill: compProps.color ? compProps.color : 'rgb(var(--v-theme-background))' }"
			></path>
		</svg>
	</div>
</template>

<script setup lang="ts">
const compProps = defineProps({
	color: {
		type: String,
		required: false,
		default: "",
	},
});
</script>

<style scoped lang="scss">
.wave {
	height: clamp(50px, 10vw, 123px);
	width: 100%;
	overflow: hidden;
	line-height: 0;
	transform: rotate(180deg);
}

.wave svg {
	position: relative;
	display: block;
	width: calc(100% + 1.3px);
	height: clamp(50px, 10vw, 123px);
}

.wave .shape-fill {
	fill: rgb(var(--v-theme-background));
}
svg {
	filter: drop-shadow(0px 0px 5px rgba(0 0 0 / 0.9));
}
</style>
